// extracted by mini-css-extract-plugin
module.exports = {"action":"TagsFilter_action__oiEb5"};